var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.idName},on:{"click":_vm.generate}},[_vm._t("default",[_vm._v(" "+_vm._s(_vm.$t('common.json_excel_download', [_vm.name]))+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }